import { render, staticRenderFns } from "./AstaFooter.vue?vue&type=template&id=21b561ca&scoped=true&"
import script from "./AstaFooter.vue?vue&type=script&lang=js&"
export * from "./AstaFooter.vue?vue&type=script&lang=js&"
import style0 from "./AstaFooter.vue?vue&type=style&index=0&id=21b561ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b561ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21b561ca')) {
      api.createRecord('21b561ca', component.options)
    } else {
      api.reload('21b561ca', component.options)
    }
    module.hot.accept("./AstaFooter.vue?vue&type=template&id=21b561ca&scoped=true&", function () {
      api.rerender('21b561ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AstaFooter.vue"
export default component.exports